import { render, staticRenderFns } from "./ServicesOverview.vue?vue&type=template&id=b9c1a3bc&"
import script from "./ServicesOverview.vue?vue&type=script&lang=js&"
export * from "./ServicesOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../whitelabel/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports